import React from 'react';
import PropTypes from 'prop-types';
import { InfoOutlined } from '@mui/icons-material';
import RowContextMenu from '../../components/DataGrid/RowContextMenu';
import DataGrid from '../../components/DataGrid/DataGrid';
import Status from '../../components/DataGrid/Status';
import OrderDetails from './OrderDetails';
import DetailDialog from '../../components/DetailDialog/DetailDialog';
import { Box } from '@mui/material';

const Orders = ({ id }) => {
    const [openDialog, setOpenDialog] = React.useState(false);
    const [current, setCurrent] = React.useState(null);
    const [dlgTitle, setDlgTitle] = React.useState('Order Details');

    const columns = [
        { field: "giftName", headerName: "Gift name", align: "left", filterable: true, permanent: true,
            render : (row) => row?.Gift?.name 
         },
        { field: "clientName", headerName: "Client name", align: "left", filterable: true, permanent: true,
            render : (row) => row?.Card?.Client?.name 
         },
        { field: "nbr_pts", headerName: "Points", align: "right", filterable: true, },
        { field: "quantity", headerName: "Qte", align: "right", filterable: true },
        { field: "status", headerName: "Status", align: "center", filterable: true,
            render : (row) => <Status value={row.status} />
         },
    ];

    // Define actions outside the RowContextMenu
    const rowActions = [
        { name: "Info", icon: <InfoOutlined fontSize="small" />, onClick: (row) => {
            const data = {
                giftName: row?.Gift?.name,
                clientName: row?.Card?.Client?.name,
                nbr_pts: row.nbr_pts,
                quantity: row.quantity,
                status: row.status,
            };
            setDlgTitle(row?.giftName||'Information');
            setCurrent(data);
            setOpenDialog(true);
        } },
    ];

    const CustomRowContextMenu = (props) => {
        return <RowContextMenu {...props} actions={rowActions} />
    }

    return (
        <div>
            <DataGrid 
                columns={columns} 
                endPoint={`/api/v2/partner/${id}/orders`}  
                RowContextMenu={CustomRowContextMenu} 
                exportFileName='Orders' 
            />
            <DetailDialog 
                open={openDialog} 
                onClose={()=>setOpenDialog(false)} 
                title={dlgTitle}
                fullScreen={false}>
                    <Box sx={{p:2}}>
                        <OrderDetails data={current} />
                    </Box>
            </DetailDialog>
        </div>
    );
};

Orders.propTypes = {
    id: PropTypes.string.isRequired,
};

export default Orders;